var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#feb730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_",
    "data-name": "g+",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0.185 3.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M435.85,287.1v.054h-1.969v1.97h-1.54v-1.97h-1.965v-1.536h1.965v-1.968h1.54v1.968h1.969V287.1Z",
    transform: "translate(-418.035 -281.039)",
    fill: "#feb730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M421.747,284.013a6.065,6.065,0,0,1-.965,4.759,4.951,4.951,0,0,1-2.78,1.823,6.047,6.047,0,0,1-1.848.181,5.472,5.472,0,0,1-3.007-1.064,5.585,5.585,0,0,1-2.209-3.373,5.273,5.273,0,0,1-.117-1.516,5.66,5.66,0,0,1,4.27-5.154,4.655,4.655,0,0,1,.932-.145c.18-.007.36-.021.541-.016a5.319,5.319,0,0,1,2.671.728,6.606,6.606,0,0,1,1,.734c-.55.556-1.092,1.1-1.637,1.645a3.035,3.035,0,0,0-1.658-.8,3.329,3.329,0,0,0-3.71,2.592,3.181,3.181,0,0,0-.068,1.025,3.332,3.332,0,0,0,3.55,3.076,3.22,3.22,0,0,0,1.637-.531,2.569,2.569,0,0,0,1.113-1.7h-3.024v-2.174a.479.479,0,0,1,.006-.093Z",
    transform: "translate(-410.809 -279.507)",
    fill: "#feb730"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g+.6c288054dd9cbc78f1c70dcc7ed7c935.svg";
export { ForwardRef as ReactComponent };